import dayjs from 'dayjs'
import 'dayjs/locale/ru'

dayjs.locale('ru')

export { dayjs }
